





import {defineComponent} from "@vue/composition-api"
import {logout} from "@/data/api/auth"

export default defineComponent({
  setup() {
    setTimeout(() => {
      logout()
    }, 1000)
    return {}
  },
})
